export const appSettingsObjectsUsingCustomAttributes = "/app_settings/objects_using_custom_attributes";
